export default __webpack_public_path__ + "static/media/diamondSafira.529d9070.svg";